import {blankDashboardType, dashboardType} from './dashboardtype'
import store from "../store";
import Collegeindex from '../views/dashboard/Collegeindex.vue'
import TeacherIndex from "../views/dashboard/TeacherIndex";
import Candindex from "../views/dashboard/Candindex";
import Students from "@/views/Students";

export function dashboardRoutes(){
        return dashboardType()
}

export function blankDashboardRoutes(){
        return blankDashboardType()
}

export function indexRoute() {
        if (store.getters.getUserType === "") {
                return Students;
        } else if (store.getters.getUserType === "Individual") {
                return Candindex;
        } else if (store.getters.getUserType === "teacher") {
                return TeacherIndex;
        } else {
                return Collegeindex;
        }
}